<template>
  <div class="circle-progress" :data-pct="value" :style="styles">
    <svg
      :width="size"
      :height="size"
      viewPort="0 0 100 100"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        :r="radius"
        :cx="size / 2"
        :cy="size / 2"
        fill="transparent"
        stroke-dasharray="0"
        stroke-dashoffset="0"
        :style="circleStyles"
      />
      <circle
        class="bar"
        :r="radius"
        :cx="size / 2"
        :cy="size / 2"
        fill="transparent"
        :stroke-dasharray="len"
        :style="barCircleStyles"
      />
      <text
        :x="size / 2"
        :y="size / 2 + size * 0.05"
        text-anchor="middle"
        :style="textStyles"
      >
        {{ value.toFixed(0) }}%
      </text>
    </svg>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  props: {
    value: { type: Number, default: 0 },
    size: { type: Number, default: 40 },
  },
  data() {
    return {}
  },
  computed: {
    radius: function () {
      return this.size * 0.45
    },
    len: function () {
      return 2 * Math.PI * this.radius
    },
    dashoffset: function () {
      const p = this.value / 100
      return (1 - p) * this.len
    },
    styles: function () {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
      }
    },
    circleStyles: function () {
      let width = this.size * 0.1
      if (width < 1) width = 2
      width = width - 1
      return {
        'stroke-width': width + 'px',
      }
    },
    barCircleStyles: function () {
      return Object.assign(
        {
          'stroke-dashoffset': this.dashoffset,
        },
        this.circleStyles,
      )
    },
    textStyles: function () {
      const textSize = Math.floor(this.size * 0.25) + 2
      return {
        'font-size': textSize + 'px',
      }
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.circle-progress text {
  font-family: 'Roboto';
  stroke: white;
}

.circle-progress circle {
  stroke-dashoffset: 0;
  transition: stroke-dashoffset 0.5s ease-in-out;
  stroke: #666;
  stroke-width: 9px;
}
.circle-progress .bar {
  stroke: $bright;
}
.circle-progress {
  display: block;
  background-color: black;
  margin: 0em auto;
  box-shadow: 0 0 1em black;
  border-radius: 100%;
  position: relative;
}
.circle-progress::afterx {
  position: absolute;
  display: block;
  height: 160px;
  width: 160px;
  left: 50%;
  top: 50%;
  box-shadow: inset 0 0 1em black;
  //content: attr(data-pct)"%";
  margin-top: -80px;
  margin-left: -80px;
  border-radius: 100%;
  line-height: 160px;
  font-size: 2em;
  text-shadow: 0 0 0.5em black;
}
</style>
